import React from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';

import Navbar from './navbar/navbar';
import Home from './home/home';
import Services from './services/services';
import About from './about/about';
import FinalCTA from './cta';
import Contact from './contact/contact';
import Portfolio from './portfolio/portfolio';
import Footer from './footer/footer';

import PressReleaseTemplate from './caseStudies/PressReleaseTemplate';
import OfflineEventTemplate from './offlineEvents/OfflineEventTemplate';
import DigitalMarketingTemplate from './digitalMarketing/DigitalMarketingTemplate';

import ScrollToTop from './ScrollToTop';

import './App.css';

function App() {

  return (

    <Router>

      {/* GLOBAL SCROLL TO TOP */}
      <ScrollToTop />

      <div className="App">

        {/* NAVBAR */}
        <Navbar />

        {/* MAIN ROUTES */}
        <main>

          <Routes>

            {/* HOME */}
            <Route
              path="/"
              element={<Home />}
            />

            {/* ABOUT */}
            <Route
              path="/about"
              element={<About />}
            />

            {/* SERVICES */}
            <Route
              path="/services"
              element={<Services />}
            />

            {/* PORTFOLIO */}
            <Route
              path="/portfolio"
              element={<Portfolio />}
            />

            {/* CONTACT */}
            <Route
              path="/contact"
              element={<Contact />}
            />

            {/* PRESS RELEASE TEMPLATE */}
            <Route
              path="/portfolio/:slug"
              element={<PressReleaseTemplate />}
            />

            {/* OFFLINE EVENTS TEMPLATE */}
            <Route
              path="/events/:slug"
              element={<OfflineEventTemplate />}
            />

            {/* DIGITAL MARKETING TEMPLATE */}
            <Route
              path="/digital-marketing/:slug"
              element={<DigitalMarketingTemplate />}
            />

          </Routes>

        </main>

        {/* CTA */}
        <FinalCTA />

        {/* FOOTER */}
        <Footer />

      </div>

    </Router>

  );
}

export default App;